'use strict';

import type { UserCommissionSchedule } from '../../Entities/User/UserCommissionSchedule';
import { EntityCollection } from '../EntityCollection';

export class UserCommissionScheduleCollection extends EntityCollection<UserCommissionSchedule> {}
